import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'containers/Leads/actions';
import Leads from './Leads';
import './styles.scss';

const LeadsIndex = () => {
  const firstFiltersLoadComplete = useSelector(state => state.leads.firstFiltersLoadComplete);
  const filters = useSelector(state => state.leads.filters);
  const orgId = useSelector((state) => state.global.userInfo.orgId);

  const dispatch = useDispatch();
  const { getLeadsFilters, getOrgMembers } = bindActionCreators(actions, dispatch);
  const leadsCount = useMemo(() => {
    if (firstFiltersLoadComplete) {
      if (filters.length) {
        return filters?.reduce((sum, status) => sum + status.count, 0);
      }
      return -1;
    }
  }, [firstFiltersLoadComplete]);

  useEffect(() => {
    if (!firstFiltersLoadComplete) {
      // When using back button on safari, need to reload query
      // because back-forward cache prevents this page from knowing
      // if new leads are created.
      window.onpageshow = (event) => {
        if (event.persisted) getLeadsFilters();
      };
      getLeadsFilters();
    }
  }, []);

  useEffect(() => {
    window.onpageshow = (event) => {
      if (event.persisted && orgId) {
        getOrgMembers({ variables: { orgId } });
      }
    };

    if (orgId) {
      getOrgMembers({ variables: { orgId } });
    }
  }, [orgId]);

  if (!firstFiltersLoadComplete || leadsCount < 0) return null;

  return (
    <Leads leadsCount={leadsCount} />
  );
};

export default LeadsIndex;
